/**
 * Moon Energy — Lookbook (Shopify vanilla JS port of Lookbook.jsx)
 * Reads window.__lookbookPhotos set in main-lookbook.liquid
 */
(function () {
  'use strict';

  var PHOTOS = window.__lookbookPhotos || [];
  if (!PHOTOS.length) return;

  var SWIPE_THRESHOLD = 50;
  var SWIPE_TIME_LIMIT = 400;
  var TAP_MOVE_LIMIT = 10;
  var IDLE_DELAY = 30000;
  var AUTO_PLAY_INTERVAL = 10000;
  var CROSSFADE_MS = 350;

  var current = 0;
  var transitioning = false;
  var isAutoPlaying = false;
  var autoPlayTimer = null;
  var idleTimer = null;
  var touchStart = null;
  var lbTouchStart = null;
  var lbTransitioning = false;
  var lbControlsVisible = true;
  var lbIdleTimer = null;
  var lightboxOpen = false;
  var gridOpen = false;

  // ---- DOM refs ----
  var stage       = document.getElementById('lookbook-stage');
  var photoEl     = document.getElementById('lookbook-photo');
  var prevBtn      = document.getElementById('lb-prev');
  var nextBtn      = document.getElementById('lb-next');
  var expandBtn    = document.getElementById('lb-expand');
  var gridOpenBtn  = document.getElementById('lb-grid-open');
  var counterEl    = document.getElementById('lb-counter');
  var dotsEl       = document.getElementById('lb-dots');
  var progressWrap = document.getElementById('lb-progress-wrap');

  var lightboxEl   = document.getElementById('lb-lightbox');
  var lbImgEl      = document.getElementById('lb-lightbox-img');
  var lbUiEl       = document.getElementById('lb-ui');
  var lbCloseBtn   = document.getElementById('lb-close');
  var lbLbCounter  = document.getElementById('lb-lb-counter');
  var lbNavPrev    = document.getElementById('lb-nav-prev');
  var lbNavNext    = document.getElementById('lb-nav-next');
  var lbDotStrip   = document.getElementById('lb-dot-strip');

  var gridOverlay  = document.getElementById('lb-grid-overlay');
  var gridClose    = document.getElementById('lb-grid-close');
  var gridEl       = document.getElementById('lb-grid');

  // Reparent fullscreen overlays to <body> so they escape .main-content's
  // stacking context (which otherwise traps them beneath the fixed navbar,
  // making their close buttons unclickable and visually overlapped).
  if (lightboxEl && lightboxEl.parentNode !== document.body) document.body.appendChild(lightboxEl);
  if (gridOverlay && gridOverlay.parentNode !== document.body) document.body.appendChild(gridOverlay);

  // ---- Build dot strip ----
  function buildDots() {
    dotsEl.innerHTML = '';
    PHOTOS.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'lb-dot' + (i === current ? ' lb-dot--active' : '');
      d.setAttribute('aria-label', 'Photo ' + (i + 1));
      d.addEventListener('click', function (e) {
        e.stopPropagation();
        resetIdleTimer();
        goTo(i);
      });
      dotsEl.appendChild(d);
    });
  }

  function updateDots() {
    var all = dotsEl.querySelectorAll('.lb-dot');
    all.forEach(function (d, i) {
      d.className = 'lb-dot' + (i === current ? ' lb-dot--active' : '');
    });
  }

  function updateCounter() {
    var n = String(current + 1).padStart(2, '0');
    var t = String(PHOTOS.length).padStart(2, '0');
    if (counterEl) counterEl.textContent = n + ' / ' + t;
    if (lbLbCounter) lbLbCounter.textContent = n + ' / ' + t;
  }

  // ---- Crossfade: new image fades in on top; old removed after ----
  function crossfadeTo(index) {
    if (!photoEl) return;

    var incoming = new Image();
    incoming.className = 'lookbook-photo lookbook-photo--incoming';
    incoming.src = PHOTOS[index].src;
    incoming.alt = PHOTOS[index].alt;
    incoming.draggable = false;

    if (stage) {
      stage.appendChild(incoming);
    } else {
      photoEl.parentNode.insertBefore(incoming, photoEl.nextSibling);
    }

    // Force reflow so transition starts from opacity 0
    incoming.getBoundingClientRect();

    incoming.classList.add('lookbook-photo--fade-in');

    setTimeout(function () {
      photoEl.src = PHOTOS[index].src;
      photoEl.alt = PHOTOS[index].alt;
      photoEl.className = 'lookbook-photo';
      if (incoming.parentNode) incoming.parentNode.removeChild(incoming);
    }, CROSSFADE_MS);
  }

  function goTo(index) {
    if (index === current || transitioning) return;
    transitioning = true;
    var next = index;

    if (lbImgEl) {
      lbImgEl.src = PHOTOS[next].src;
      lbImgEl.alt = PHOTOS[next].alt;
    }

    crossfadeTo(next);
    current = next;
    updateCounter();
    updateDots();
    updateLbDotStrip();

    setTimeout(function () { transitioning = false; }, CROSSFADE_MS);
  }

  function goPrev() {
    goTo((current - 1 + PHOTOS.length) % PHOTOS.length);
  }

  function goNext() {
    goTo((current + 1) % PHOTOS.length);
  }

  // ---- Autoplay ----
  function stopAutoPlay() {
    clearInterval(autoPlayTimer);
    autoPlayTimer = null;
    isAutoPlaying = false;
    if (progressWrap) progressWrap.innerHTML = '';
  }

  function startAutoPlay() {
    stopAutoPlay();
    isAutoPlaying = true;
    renderProgressBar();
    autoPlayTimer = setInterval(function () {
      goNext();
      renderProgressBar();
    }, AUTO_PLAY_INTERVAL);
  }

  function renderProgressBar() {
    if (!progressWrap) return;
    progressWrap.innerHTML = '';
    if (!isAutoPlaying) return;
    var bar = document.createElement('div');
    bar.className = 'lb-progress-bar';
    progressWrap.appendChild(bar);
  }

  function resetIdleTimer() {
    stopAutoPlay();
    clearTimeout(idleTimer);
    idleTimer = setTimeout(startAutoPlay, IDLE_DELAY);
  }

  // ---- Lightbox ----
  function showLbControls() {
    lbControlsVisible = true;
    if (lbUiEl) {
      lbUiEl.className = 'lb-ui lb-ui--visible';
      lbUiEl.querySelectorAll('button').forEach(function (b) { b.style.pointerEvents = 'auto'; });
    }
    clearTimeout(lbIdleTimer);
    lbIdleTimer = setTimeout(function () {
      lbControlsVisible = false;
      if (lbUiEl) lbUiEl.className = 'lb-ui lb-ui--hidden';
    }, 3000);
  }

  function openLightbox() {
    lightboxOpen = true;
    lbTransitioning = false;
    if (lightboxEl) lightboxEl.style.display = 'block';
    if (lbImgEl) {
      lbImgEl.src = PHOTOS[current].src;
      lbImgEl.alt = PHOTOS[current].alt;
      lbImgEl.className = 'lb-lightbox-img';
    }
    updateCounter();
    updateLbDotStrip();
    showLbControls();
  }

  function closeLightbox() {
    lightboxOpen = false;
    clearTimeout(lbIdleTimer);
    if (lightboxEl) lightboxEl.style.display = 'none';
    if (lbUiEl) lbUiEl.className = 'lb-ui lb-ui--visible';
  }

  function goToLb(index, dir) {
    if (index === current || lbTransitioning) return;
    lbTransitioning = true;
    showLbControls();
    current = index;
    if (lbImgEl) {
      lbImgEl.className = 'lb-lightbox-img' + (dir === 'next' ? ' lbdir-next-img' : ' lbdir-prev-img');
      lbImgEl.src = PHOTOS[current].src;
      lbImgEl.alt = PHOTOS[current].alt;
    }
    if (lightboxEl) {
      lightboxEl.className = 'lb-lightbox' + (dir ? ' lbdir-' + dir : '');
    }
    updateCounter();
    updateLbDotStrip();
    setTimeout(function () {
      lbTransitioning = false;
      if (lightboxEl) lightboxEl.className = 'lb-lightbox';
    }, 220);
  }

  function updateLbDotStrip() {
    if (!lbDotStrip) return;
    var DOT_COUNT = Math.min(PHOTOS.length, 7);
    var half = Math.floor(DOT_COUNT / 2);
    var winStart = Math.min(Math.max(current - half, 0), PHOTOS.length - DOT_COUNT);
    lbDotStrip.innerHTML = '';
    for (var i = 0; i < DOT_COUNT; i++) {
      var idx = winStart + i;
      var d = document.createElement('button');
      d.className = 'lb-dot' + (idx === current ? ' lb-dot--active' : '');
      d.setAttribute('aria-label', 'Photo ' + (idx + 1));
      (function (photoIdx) {
        d.addEventListener('click', function (e) {
          e.stopPropagation();
          goToLb(photoIdx, photoIdx > current ? 'next' : 'prev');
        });
      })(idx);
      lbDotStrip.appendChild(d);
    }
  }

  // ---- Grid ----
  function buildGrid() {
    if (!gridEl) return;
    gridEl.innerHTML = '';
    PHOTOS.forEach(function (photo, i) {
      var btn = document.createElement('button');
      btn.className = 'lb-thumb' + (i === current ? ' selected' : '');
      var img = document.createElement('img');
      img.src = photo.src;
      img.alt = photo.alt;
      img.draggable = false;
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        resetIdleTimer();
        goTo(i);
        closeGrid();
      });
      gridEl.appendChild(btn);
    });
  }

  function openGrid() {
    gridOpen = true;
    buildGrid();
    if (gridOverlay) gridOverlay.style.display = 'flex';
  }

  function closeGrid() {
    gridOpen = false;
    if (gridOverlay) gridOverlay.style.display = 'none';
  }

  // ---- Touch handling (main stage) ----
  if (photoEl) {
    photoEl.addEventListener('touchstart', function (e) {
      resetIdleTimer();
      var t = e.touches[0];
      touchStart = { x: t.clientX, y: t.clientY, time: Date.now() };
    }, { passive: true });

    photoEl.addEventListener('touchend', function (e) {
      if (!touchStart) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStart.x;
      var dy = t.clientY - touchStart.y;
      var dt = Date.now() - touchStart.time;
      touchStart = null;

      var absDx = Math.abs(dx), absDy = Math.abs(dy);
      if (absDx < TAP_MOVE_LIMIT && absDy < TAP_MOVE_LIMIT) {
        openLightbox();
        return;
      }
      if (absDx > SWIPE_THRESHOLD && absDx > absDy && dt < SWIPE_TIME_LIMIT) {
        resetIdleTimer();
        goTo(dx < 0
          ? (current + 1) % PHOTOS.length
          : (current - 1 + PHOTOS.length) % PHOTOS.length);
      }
    }, { passive: true });
  }

  // ---- Touch handling (lightbox) ----
  if (lightboxEl) {
    lightboxEl.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      lbTouchStart = { x: t.clientX, y: t.clientY, time: Date.now() };
    }, { passive: true });

    lightboxEl.addEventListener('touchend', function (e) {
      if (!lbTouchStart) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - lbTouchStart.x;
      var dy = t.clientY - lbTouchStart.y;
      var dt = Date.now() - lbTouchStart.time;
      lbTouchStart = null;

      var absDx = Math.abs(dx), absDy = Math.abs(dy);
      if (absDx < TAP_MOVE_LIMIT && absDy < TAP_MOVE_LIMIT) {
        if (!e.target.closest('button')) {
          if (lbControlsVisible) {
            clearTimeout(lbIdleTimer);
            lbControlsVisible = false;
            if (lbUiEl) lbUiEl.className = 'lb-ui lb-ui--hidden';
          } else {
            showLbControls();
          }
        }
        return;
      }
      if (absDx > SWIPE_THRESHOLD && absDx > absDy && dt < SWIPE_TIME_LIMIT) {
        e.preventDefault();
        goToLb(
          dx < 0
            ? (current + 1) % PHOTOS.length
            : (current - 1 + PHOTOS.length) % PHOTOS.length,
          dx < 0 ? 'next' : 'prev'
        );
      }
    });

    lightboxEl.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      if (lbControlsVisible) {
        clearTimeout(lbIdleTimer);
        lbControlsVisible = false;
        if (lbUiEl) lbUiEl.className = 'lb-ui lb-ui--hidden';
      } else {
        showLbControls();
      }
    });
  }

  // ---- Grid overlay click outside ----
  if (gridOverlay) {
    gridOverlay.addEventListener('click', function (e) {
      if (e.target === gridOverlay) { resetIdleTimer(); closeGrid(); }
    });
  }

  // ---- Keyboard ----
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (lightboxOpen) { closeLightbox(); return; }
      if (gridOpen) { resetIdleTimer(); closeGrid(); return; }
    }
    if (gridOpen) return;
    if (e.key === 'ArrowLeft') {
      if (lightboxOpen) { goToLb((current - 1 + PHOTOS.length) % PHOTOS.length, 'prev'); }
      else { resetIdleTimer(); goPrev(); }
    }
    if (e.key === 'ArrowRight') {
      if (lightboxOpen) { goToLb((current + 1) % PHOTOS.length, 'next'); }
      else { resetIdleTimer(); goNext(); }
    }
  });

  // ---- Button events ----
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); resetIdleTimer(); goPrev(); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); resetIdleTimer(); goNext(); });
  if (expandBtn) expandBtn.addEventListener('click', function () { resetIdleTimer(); openLightbox(); });
  if (gridOpenBtn) gridOpenBtn.addEventListener('click', function () { resetIdleTimer(); openGrid(); });
  if (lbCloseBtn) lbCloseBtn.addEventListener('click', function () { clearTimeout(lbIdleTimer); closeLightbox(); });
  if (lbNavPrev) lbNavPrev.addEventListener('click', function (e) { e.stopPropagation(); goToLb((current - 1 + PHOTOS.length) % PHOTOS.length, 'prev'); });
  if (lbNavNext) lbNavNext.addEventListener('click', function (e) { e.stopPropagation(); goToLb((current + 1) % PHOTOS.length, 'next'); });
  if (gridClose) gridClose.addEventListener('click', function () { resetIdleTimer(); closeGrid(); });

  // ---- Prevent drag ----
  document.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });

  // ---- Init ----
  buildDots();
  if (photoEl) {
    photoEl.src = PHOTOS[0].src;
    photoEl.alt = PHOTOS[0].alt;
    photoEl.className = 'lookbook-photo';
  }
  resetIdleTimer();

})();
